import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { FloatingElements } from './FloatingElements';
import { useGeoPrice } from '../hooks/useGeoPrice';
const questionVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const yesVariants = {
  hidden: {
    opacity: 0,
    scale: 0.5
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      type: 'spring',
      stiffness: 200,
      damping: 12
    }
  }
};
export function TripleYes() {
  const {
    symbol,
    offerPrice,
    label
  } = useGeoPrice();
  return <section className="bg-dark py-24 md:py-36 px-5 relative overflow-hidden" data-id="element-307">
      <div className="absolute inset-0 bg-radial-money" aria-hidden="true" data-id="element-308" />
      <FloatingElements count={10} variant="money" data-id="element-309" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-310">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-311">
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white leading-tight" data-id="element-312">
            Respóndete <span className="text-gradient-money" data-id="element-313">3 preguntas</span>
          </h2>
        </motion.div>

        {/* Question 1 */}
        <motion.div className="mb-12" variants={questionVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-314">
          <div className="bg-dark-card border border-dark-border rounded-2xl p-7 md:p-8 mb-4" data-id="element-315">
            <p className="font-display text-xl md:text-2xl font-bold text-white leading-snug" data-id="element-316">
              ¿Quieres que tu hijo aprenda a manejar dinero{' '}
              <span className="text-money" data-id="element-317">SIN peleas</span>,{' '}
              <span className="text-money" data-id="element-318">SIN gritos</span> y{' '}
              <span className="text-money" data-id="element-319">SIN culpa</span>?
            </p>
          </div>
          <motion.div className="flex items-center justify-center gap-3" variants={yesVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} data-id="element-320">
            <CheckCircleIcon className="w-8 h-8 text-money" data-id="element-321" />
            <span className="font-display text-4xl md:text-5xl font-extrabold text-money" data-id="element-322">
              SÍ
            </span>
          </motion.div>
        </motion.div>

        {/* Question 2 */}
        <motion.div className="mb-12" variants={questionVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-323">
          <div className="bg-dark-card border border-dark-border rounded-2xl p-7 md:p-8 mb-4" data-id="element-324">
            <p className="font-display text-xl md:text-2xl font-bold text-white leading-snug" data-id="element-325">
              ¿Te gustaría tener un sistema{' '}
              <span className="text-money" data-id="element-326">PROBADO</span> que funcione en solo{' '}
              <span className="text-money" data-id="element-327">7 minutos por semana</span>?
            </p>
          </div>
          <motion.div className="flex items-center justify-center gap-3" variants={yesVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} data-id="element-328">
            <CheckCircleIcon className="w-8 h-8 text-money" data-id="element-329" />
            <span className="font-display text-4xl md:text-5xl font-extrabold text-money" data-id="element-330">
              SÍ
            </span>
          </motion.div>
        </motion.div>

        {/* Question 3 */}
        <motion.div className="mb-16" variants={questionVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-331">
          <div className="bg-dark-card border border-dark-border rounded-2xl p-7 md:p-8 mb-4" data-id="element-332">
            <p className="font-display text-xl md:text-2xl font-bold text-white leading-snug" data-id="element-333">
              ¿Estás listo para instalar ese sistema en tu casa{' '}
              <span className="text-gold font-extrabold" data-id="element-334">HOY</span>?
            </p>
          </div>
          <motion.div className="flex items-center justify-center gap-3" variants={yesVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} data-id="element-335">
            <CheckCircleIcon className="w-8 h-8 text-money" data-id="element-336" />
            <span className="font-display text-4xl md:text-5xl font-extrabold text-money" data-id="element-337">
              SÍ
            </span>
          </motion.div>
        </motion.div>

        {/* Transition + CTA */}
        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} viewport={{
        once: true,
        margin: '-40px'
      }} data-id="element-338">
          <p className="font-display text-2xl md:text-3xl font-extrabold text-white mb-10" data-id="element-339">
            Entonces esto es para ti.
          </p>

          <a href="https://pay.hotmart.com/R104423897O" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-to-r from-money-dark via-money to-emerald-400 text-white font-display font-extrabold text-xl md:text-2xl px-12 py-6 rounded-2xl cta-pulse hover:scale-[1.03] active:scale-[0.98] transition-transform duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-money focus-visible:ring-offset-2 focus-visible:ring-offset-dark" data-id="element-340">
            🔓 SUPER PROMO — {symbol}
            {offerPrice} {label}
          </a>
        </motion.div>
      </div>
    </section>;
}